import "./style.scss";

const MobileLineBreak = () => {
	return (
		<div className="mobile-line-break">
			<div className="mobile-line-break__line"></div>
		</div>
	);
};

const DesktopLineBreak = () => {
	return (
		<div className="desktop-line-break">
			<div className="desktop-line-break__line"></div>
		</div>
	);
};

export { MobileLineBreak, DesktopLineBreak };
